export default __webpack_public_path__ + "static/media/img-0189-ireland-half-face.60663183.png";